/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Hub_SubtitleInputs */

const cs_social_hub_subtitle = /** @type {(inputs: Social_Hub_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořte plakát k nemovitosti, samostatný Typst příspěvek nebo vlastní média — pak publikujte na Facebook a Instagram.`)
};

const en_social_hub_subtitle = /** @type {(inputs: Social_Hub_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a property poster, standalone Typst post, or custom media — then publish to Facebook and Instagram.`)
};

/**
* | output |
* | --- |
* | "Create a property poster, standalone Typst post, or custom media — then publish to Facebook and Instagram." |
*
* @param {Social_Hub_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_hub_subtitle = /** @type {((inputs?: Social_Hub_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Hub_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_hub_subtitle(inputs)
	return cs_social_hub_subtitle(inputs)
});